import { Component, OnDestroy, OnInit } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { SzamlazoService } from '../szamlazo.service';
import { AeAtvitel, AeEszkozService, valaszBont } from '../ae-eszkoz.service';

/*  KASSZA – bolti eladás. A termékek bruttó (bolti) áron kerülnek a kosárba; a nyugta egy lépésben,
 *  mai kelttel készül (a kiszolgáló a bruttóból számol vissza, így a végösszeg forintra a kiírt ár).
 *  A NAV-hoz nem egyenként megy: a nap összesítőjét a program küldi be a nap lezárása után.
 *  E-PÉNZTÁRGÉPPEL (Beállítások → E-pénztárgép) a nyugtát az AE állítja ki; ha a válasza elmarad, a nyugta
 *  függőben marad, és ugyanazzal a kéréssel ismételhető – új eladás nem keletkezik.
 *  Két mód: 'atjaro' – a szerver hívja az AE-átjárót; 'eszkoz' – a gépet a böngésző éri el (USB-C, Bluetooth, digitális
 *  iker – ae-eszkoz.service.ts): a szerver adja a parancsot, a böngésző küldi, a gép nyers válaszát a szerver ellenőrzi. */
interface Kosar { termek_id?: string; megnevezes: string; fajta: string; egyseg: string; mennyiseg: number; bruttoar: number; afa_kulcs: string; }

const BLOKK_KULCS = 'szamlazoBlokkNyomtato';

@Component({
  selector: 'app-szamlazo-kassza',
  templateUrl: './kassza.component.html',
  styleUrls: ['../../naplo/naplo-shared.scss', '../szamlazo-shared.scss', './kassza.component.scss'],
})
export class KasszaComponent implements OnInit, OnDestroy {
  termekek: any[] = [];
  kereso = '';
  kosar: Kosar[] = [];
  fizmod = 'CASH';
  kapott: number | null = null;
  fut = false;
  utolso: any = null;
  ae: any = null;                       // { van, mod, allapot?, hiba?, fuggo[], nyomtatatlan[] }
  /** Az AE nyomtatója nem nyomtatott (esemény vagy printed=0) – figyelmeztetés, amíg egy nyomtatás nem sikerül. */
  nyomtatoHiba = '';
  /** E-pénztárgép nélkül, az asztali programban: a nyugta közvetlenül a kiválasztott blokknyomtatóra megy (80 mm). */
  blokk = { nyomtato: '', lista: [] as any[], szel: 80 };
  /** Külső pénztárgép (pl. Micra): a pénztárgépnek átadandó, még nem jelzett eladások és a nyitott átadás. */
  pg: { tipus: string | null; nev: string | null; fuggo: any[] } = { tipus: null, nev: null, fuggo: [] };
  pgAtadas: { id: string; szamlaszam: string; brutto: number; pg: any; index: number } | null = null;
  iker = { url: '', kulcs: '' };
  egyedi = { megnevezes: '', bruttoar: null as number | null, afa_kulcs: '27' };
  private sub?: Subscription;
  private esemenySub?: Subscription;
  constructor(public sz: SzamlazoService, public aeE: AeEszkozService, private toast: ToastController) { this.iker = this.aeE.ikerBeallitas(); }
  get u() { return this.sz.aktiv.ugyfelId; }
  get ir() { return this.sz.ir; }

  async ngOnInit() {
    await this.sz.init(); this.sub = this.sz.aktiv$.subscribe(() => this.betolt());
    await this.blokkBetolt();
    //  A gép kérés nélkül is jelez: !EVT|PRINTER|UNAVAILABLE – a nyomtató nem kész (papír, kábel).
    this.esemenySub = this.aeE.esemeny$.subscribe((e) => {
      if (!/^!EVT\|PRINTER\|/.test(e)) return;
      this.nyomtatoHiba = 'Az e-pénztárgép nyomtatója nem nyomtatott – nézd meg a papírt és a nyomtató kábelét (az e-pénztárgép USB-A aljzata).';
      this.hiba(this.nyomtatoHiba);
    });
  }
  ngOnDestroy() { this.sub?.unsubscribe(); this.esemenySub?.unsubscribe(); }

  /* ── blokknyomtató az asztali programban (e-pénztárgép nélkül) ── */
  private get hid(): any { return (window as any).cronomitNyomtato || null; }
  get asztali() { return !!this.hid; }
  async blokkBetolt() {
    if (!this.hid) return;
    try { this.blokk.nyomtato = localStorage.getItem(BLOKK_KULCS) || ''; this.blokk.szel = localStorage.getItem(BLOKK_KULCS + 'Szel') === '58' ? 58 : 80; } catch { /* privát ablak */ }
    try { this.blokk.lista = await this.hid.nyomtatok(); } catch { this.blokk.lista = []; }
  }
  blokkValaszt(n: string) { this.blokk.nyomtato = n; try { localStorage.setItem(BLOKK_KULCS, n); } catch { /* privát ablak */ } }
  /** A blokknyomtató papírszélessége: 80 mm (a legtöbb bolti) vagy 58 mm (kis / hordozható nyomtatók). */
  blokkSzel(v: number) { this.blokk.szel = Number(v) === 58 ? 58 : 80; try { localStorage.setItem(BLOKK_KULCS + 'Szel', String(this.blokk.szel)); } catch { /* privát ablak */ } }
  /** 'nincs' – nincs kiválasztva (PDF készül); 'hianyzik' – nincs a gépen; 'offline' / 'papir' – a rendszer szerint; 'ok'. */
  get blokkAllapot(): 'nincs' | 'hianyzik' | 'offline' | 'papir' | 'ok' {
    if (!this.blokk.nyomtato) return 'nincs';
    const p = this.blokk.lista.find((x) => x.nev === this.blokk.nyomtato);
    return !p ? 'hianyzik' : p.offline ? 'offline' : p.papirHiany ? 'papir' : 'ok';
  }
  /** Az utolsó nyugta újra: AE-nél a gépen (PRINT – eredeti vagy MÁSOLAT), különben blokknyomtató vagy PDF. */
  ujraNyomtat(r: any) {
    if (r.pg) return this.hiba('Ezt a nyugtát a pénztárgép adta – másolatot a pénztárgépen lehet nyomtatni.');
    if (r.ae) return this.aeNyomtat(r);
    return this.asztali && this.blokk.nyomtato ? this.blokkNyomtat(r) : this.sz.pdf(r.id, r.szamlaszam);
  }
  /** A nyugta 80 mm-es képe a blokknyomtatóra; ha nem megy, PDF (a nyugta ettől még kiállított). */
  private async blokkNyomtat(r: any) {
    await this.blokkBetolt();                                        // közben kihúzhatták
    if (this.blokkAllapot !== 'ok' && this.blokkAllapot !== 'offline') {
      this.hiba(this.blokkAllapot === 'hianyzik' ? `A blokknyomtató (${this.blokk.nyomtato}) nincs a gépen – a nyugta PDF-ben nyílik meg.` : 'A blokknyomtatóból kifogyott a papír – a nyugta PDF-ben nyílik meg.');
      return this.sz.pdf(r.id, r.szamlaszam);
    }
    try {
      const html = await this.sz.html(r.id, this.blokk.szel);
      const m = /size:\s*(\d+)mm\s+(\d+)mm/.exec(html);
      const e = await this.hid.nyomtat({ html, nyomtato: this.blokk.nyomtato, szelesseg_mm: m ? Number(m[1]) : this.blokk.szel, magassag_mm: m ? Number(m[2]) : 200 });
      if (!e?.ok) throw new Error(e?.hiba || '');
    } catch (e: any) {
      this.hiba(`A blokknyomtató nem nyomtatott${e?.message ? ` (${e.message})` : ''} – a nyugta PDF-ben nyílik meg.`);
      await this.sz.pdf(r.id, r.szamlaszam);
    }
  }
  /** A nyomtató állapota a gép állapotjelentéséből: printer=ready|nopaper|none (átjárós módban a /api/status, eszköz
   *  módban a STATUS-keret adja). Régebbi firmware-nél nincs ilyen mező – akkor null, és csak utólag derül ki. */
  get nyomtatoAllapot(): { ok: boolean; szoveg: string } | null {
    const v = String(this.ae?.allapot?.printer ?? '').toLowerCase();
    if (!v) return null;
    if (v === 'ready') return { ok: true, szoveg: 'nyomtató kész' };
    if (v === 'nopaper') return { ok: false, szoveg: 'nyomtató: nincs papír' };
    return { ok: false, szoveg: 'nincs nyomtató (az e-pénztárgép USB-A aljzatába kell dugni)' };
  }
  async betolt() {
    this.kosar = []; this.utolso = null;
    if (!this.u) { this.termekek = []; return; }
    try { this.termekek = (await this.sz.get<any[]>(`/termekek/${this.u}`)).filter((t) => Number(t.aktiv)); } catch { this.termekek = []; }
    await this.aeFrissit();
    await this.pgFrissit();
  }
  /* ── külső pénztárgép (szamlazo-penztargep.js) ── */
  async pgFrissit() {
    try { this.pg = this.u ? await this.sz.get(`/kassza-pg/${this.u}`) : { tipus: null, nev: null, fuggo: [] }; }
    catch { this.pg = { tipus: null, nev: null, fuggo: [] }; }
  }
  pgFolytat(f: any) { this.pgAtadas = { id: f.id, szamlaszam: f.szamlaszam, brutto: Number(f.brutto), pg: f.pg, index: 0 }; }
  get vanSoros() { return !!(navigator as any).serial; }
  /** A kódok a gép olvasóbemenetére, soros kábelen (WebSerial): 9600 8E1, kódonként CR LF. */
  async pgSoros() {
    const a = this.pgAtadas;
    if (!a) return;
    const s: any = (navigator as any).serial;
    try {
      const port = (await s.getPorts())[0] || await s.requestPort();
      const p = a.pg.soros_parameterek || { baudRate: 9600, parity: 'even', dataBits: 8, stopBits: 1, lezaras: '\r\n' };
      await port.open({ baudRate: p.baudRate, parity: p.parity, dataBits: p.dataBits, stopBits: p.stopBits });
      const iro = port.writable.getWriter();
      try {
        for (const k of a.pg.kodok) { await iro.write(new TextEncoder().encode(k.kod + (p.lezaras || '\r\n'))); await new Promise((r) => setTimeout(r, 250)); }
      } finally { iro.releaseLock(); await port.close(); }
      a.index = a.pg.kodok.length;
      this.ok(`${a.pg.kodok.length} kód elküldve a pénztárgépnek – most a gépen: ${a.pg.fizmod_nev}, ${this.szam(a.pg.osszeg)} Ft.`);
    } catch (e: any) { if (e?.name !== 'NotFoundError') this.hiba(`A soros küldés nem sikerült: ${e?.message || e}`); }
  }
  async pgJelez(mod: 'kesz' | 'megszakit') {
    const a = this.pgAtadas;
    if (!a) return;
    this.fut = true;
    try {
      const r: any = await this.sz.post(`/kassza/${this.u}/${a.id}/pg`, { mod });
      this.pgAtadas = null;
      if (mod === 'megszakit') this.ok(`${a.szamlaszam}: megszakítva – az eladás érvénytelen.`);
      else { this.utolso = { id: a.id, szamlaszam: a.szamlaszam, brutto: a.brutto, pg: true }; this.ok(`${a.szamlaszam}: rögzítve – a nyugtát a pénztárgép adta.`); }
      if (r?.ismetelt) this.ok('Ezt az eladást korábban már rögzítették.');
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült.'); }
    finally { this.fut = false; await this.pgFrissit(); }
  }
  get eszkozMod() { return this.ae?.van && this.ae.mod === 'eszkoz'; }
  async aeFrissit() {
    try { this.ae = this.u ? await this.sz.get(`/kassza-ae/${this.u}`) : null; } catch { this.ae = null; }
    //  eszköz mód: az állapotot a böngésző kérdezi közvetlenül a géptől
    if (this.eszkozMod && this.aeE.kapcsolva) {
      try { const v = valaszBont(await this.aeE.kuld('STATUS', 6000)); if (v.ok) this.ae.allapot = v.result; else this.ae.hiba = v.error; }
      catch (e: any) { this.ae.hiba = e?.message || 'Az e-pénztárgép nem válaszol.'; }
    }
  }
  async csatlakozas(a: AeAtvitel) {
    try {
      if (a === 'iker') this.aeE.ikerMent(this.iker.url.trim(), this.iker.kulcs.trim());
      await this.aeE.csatlakozik(a);
      this.ok(`E-pénztárgép csatlakoztatva (${this.aeE.nev}).`);
    } catch (e: any) { if (e?.name !== 'NotFoundError') this.hiba(e?.message || 'Nem sikerült csatlakozni.'); }
    await this.aeFrissit();
  }
  async bontas() { await this.aeE.bont(); await this.aeFrissit(); }
  /** Eszköz mód: parancs a gépnek, a nyers válasz a szervernek (az ellenőrzi és rögzíti). */
  private async eszkozValasz(id: string, parancs: string, mod: 'eladas' | 'megszakit' | 'visszahivas') {
    const nyers = await this.aeE.kuld(parancs);
    return this.sz.post(`/kassza/${this.u}/${id}/ae-valasz`, { nyers, mod });
  }
  async aeNap(muvelet: 'nyitas' | 'zaras') {
    this.fut = true;
    try {
      const r: any = this.eszkozMod ? await this.eszkozNap(muvelet) : await this.sz.post(`/kassza-ae/${this.u}/${muvelet}`);
      if (muvelet === 'nyitas') this.ok(`Nap megnyitva az e-pénztárgépen (${r.day}. zárási időszak).`);
      //  Zárás + egyeztetés: a gép összesítője a program tárolt nyugtáival összevetve (szamlazo.js aeNapzaras).
      else if (r.egyeztetes && !r.egyeztetes.egyezik) this.hiba(`Napzárás kész, de ${r.egyeztetes.figyelmeztetes}`);
      else this.ok(`Napzárás kész: ${r.docs} nyugta, ${this.szam(r.total)} Ft – egyezik a program adataival${r.egyeztetes?.visszahivott ? ` (${r.egyeztetes.visszahivott} függő nyugtát visszahívtam a gépről)` : ''}.`);
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült.'); }
    finally { this.fut = false; await this.aeFrissit(); }
  }
  /*  Eszköz mód napkezelése: nyitás = OPEN a gépnek; zárás = a függő nyugták visszahívása (GET), majd CLOSE, és a
   *  zárás nyers válaszával a szerver egyeztet (mint átjárós módban). */
  private async eszkozNap(muvelet: 'nyitas' | 'zaras') {
    if (muvelet === 'nyitas') {
      const v = valaszBont(await this.aeE.kuld('OPEN'));
      if (!v.ok) throw { error: { error: `Az e-pénztárgép elutasította: ${v.error}` } };
      return v.result;
    }
    let visszahivott = 0;
    for (const f of this.ae?.fuggo || []) {
      try { const r: any = await this.eszkozValasz(f.id, `GET|${f.id}`, 'visszahivas'); if (!r.fuggo) visszahivott++; } catch { /* függő marad */ }
    }
    const nyers = await this.aeE.kuld('CLOSE', 30000);
    return this.sz.post(`/kassza-ae/${this.u}/zaras-valasz`, { nyers, visszahivott });
  }
  async aeRendez(f: any, megszakit = false) {
    this.fut = true;
    try {
      let r: any;
      if (this.eszkozMod) {
        const p: any = await this.sz.get(`/kassza/${this.u}/${f.id}/ae-parancs`);
        r = await this.eszkozValasz(f.id, megszakit ? p.lekerdezes : p.eladas, megszakit ? 'megszakit' : 'eladas');
      } else r = await this.sz.post(`/kassza/${this.u}/${f.id}/ae`, { megszakit });
      if (r.megszakitva) this.ok(`${f.szamlaszam}: az e-pénztárgépen nem jött létre – érvénytelenítve.`);
      else this.kesz(r);
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült.'); }
    finally { this.fut = false; await this.aeFrissit(); }
  }
  /** Újranyomtatás az AE-n: ha az eredeti elmaradt, ez lesz az eredeti, különben MÁSOLAT. Új eladás nem keletkezik. */
  async aeNyomtat(f: any) {
    this.fut = true;
    try {
      let r: any = await this.sz.post(`/kassza/${this.u}/${f.id}/ae-nyomtat`, {});
      if (r.parancs) r = await this.sz.post(`/kassza/${this.u}/${f.id}/ae-nyomtat`, { nyers: await this.aeE.kuld(r.parancs) });
      this.nyomtatoHiba = '';
      this.ok(`${r.szamlaszam}: kinyomtatva${r.masolat ? ` (MÁSOLAT #${r.masolat})` : ' (eredeti)'}.`);
    } catch (e: any) { this.hiba(e?.error?.error || e?.message || 'Nem sikerült a nyomtatás.'); }
    finally { this.fut = false; await this.aeFrissit(); }
  }
  private kesz(r: any) {
    this.utolso = r;
    if (r.ae && !r.ae.nyomtatva) this.nyomtatoHiba = 'A nyugta elkészült és tárolódott, de nem nyomtatódott ki – nézd meg a papírt és a nyomtató kábelét, majd nyomtasd újra.';
    else if (r.ae) this.nyomtatoHiba = '';
    const a = r.ae ? ` · AE ${r.ae.sorszam}. nyugta${r.ae.kerekites ? `, fizetendő ${this.szam(r.ae.fizetendo)} Ft` : ''}${r.ae.nyomtatva ? '' : ' – NEM NYOMTATOTT'}${r.ae.ismetelt ? ' (már kiállított)' : ''}` : '';
    this.ok(`Nyugta kiállítva: ${r.szamlaszam} – ${this.szam(r.brutto)} Ft${a}`);
    if (r.figyelmeztetes) this.hiba(r.figyelmeztetes);
  }
  private szazalek(k: string) { return ({ '27': 27, '18': 18, '5': 5 } as any)[k] || 0; }
  bolti(t: any): number { return Math.round(Number(t.egysegar) * (1 + this.szazalek(t.afa_kulcs) / 100)); }
  get lathato() {
    const k = this.kereso.trim().toLowerCase();
    return k ? this.termekek.filter((t) => [t.nev, t.cikkszam, t.vonalkod].some((x) => String(x || '').toLowerCase().includes(k))) : this.termekek;
  }
  /*  VONALKÓDOLVASÓ: a kereső mezőbe olvasott kód + Enter → a pontosan egyező cikk a kosárba. */
  olvas() {
    const k = this.kereso.trim();
    const t = this.termekek.find((x) => x.vonalkod && String(x.vonalkod) === k) || (this.lathato.length === 1 ? this.lathato[0] : null);
    if (t) { this.hozzaad(t); this.kereso = ''; }
  }

  hozzaad(t: any) {
    const van = this.kosar.find((x) => x.termek_id === t.id);
    if (van) { van.mennyiseg += 1; return; }
    this.kosar.push({ termek_id: t.id, megnevezes: t.nev, fajta: t.fajta, egyseg: t.egyseg, mennyiseg: 1, bruttoar: this.bolti(t), afa_kulcs: t.afa_kulcs });
  }
  egyediHozzaad() {
    if (!this.egyedi.megnevezes.trim() || !(Number(this.egyedi.bruttoar) > 0)) return;
    this.kosar.push({ megnevezes: this.egyedi.megnevezes.trim(), fajta: 'PRODUCT', egyseg: 'db', mennyiseg: 1, bruttoar: Number(this.egyedi.bruttoar), afa_kulcs: this.egyedi.afa_kulcs });
    this.egyedi = { megnevezes: '', bruttoar: null, afa_kulcs: this.egyedi.afa_kulcs };
  }
  torol(i: number) { this.kosar.splice(i, 1); }
  get vegosszeg(): number { return this.kosar.reduce((n, x) => n + Math.round(Number(x.mennyiseg) * Number(x.bruttoar)), 0); }
  get visszajaro(): number | null { return this.fizmod === 'CASH' && this.kapott ? Number(this.kapott) - this.vegosszeg : null; }

  async nyugta() {
    if (!this.kosar.length) return;
    this.fut = true;
    try {
      let r: any = await this.sz.post(`/kassza/${this.u}`, { fizmod: this.fizmod, tetelek: this.kosar });
      this.kosar = []; this.kapott = null;
      if (r.ae_fuggo && r.ae_parancs) {
        //  eszköz mód: a nyugta függőben rögzült; a gépnek a böngésző küldi. Ha ez elmarad, a függők között újraküldhető.
        try { r = await this.eszkozValasz(r.id, r.ae_parancs, 'eladas'); }
        catch (e: any) { if (e?.error) throw e; throw { error: { error: `${r.szamlaszam}: ${e?.message || 'az e-pénztárgép nem válaszolt'} – a nyugta függőben van, újraküldhető.`, ujraprobalhato: true } }; }
      }
      //  Külső pénztárgép: a kosár a gépnek megy (kódok); a nyugtát a gép adja, a pénztáros jelzi, hogy kész.
      if (r.pg) { this.pgAtadas = { id: r.id, szamlaszam: r.szamlaszam, brutto: Number(r.brutto), pg: r.pg, index: 0 }; await this.pgFrissit(); return; }
      this.kesz(r);
      //  AE-nél a nyomat az e-pénztárgépé (a nyomtató az AE USB-A-jába dugva); nélküle a gépre dugott blokknyomtató
      //  (asztali program) vagy PDF.
      if (!r.ae) await (this.asztali && this.blokk.nyomtato ? this.blokkNyomtat(r) : this.sz.pdf(r.id, r.szamlaszam));
    } catch (e: any) {
      //  Függőben maradt (a kérés célba érhetett): a kosár nem marad meg, a nyugta a függők között ismételhető.
      if (e?.error?.ujraprobalhato) { this.kosar = []; this.kapott = null; }
      this.hiba(e?.error?.error || 'Nem sikerült a nyugta.');
    }
    finally { this.fut = false; if (this.ae?.van) await this.aeFrissit(); }
  }
  szam(v: any) { return Number(v || 0).toLocaleString('hu-HU', { maximumFractionDigits: 0 }); }
  kulcsNev(k: string) { return this.sz.torzs.afa_kulcsok.find((x) => x.kod === k)?.nev?.split(' ')[0] || k; }
  private async ok(m: string) { (await this.toast.create({ message: m, duration: 2600, color: 'success' })).present(); }
  private async hiba(m: string) { (await this.toast.create({ message: m, duration: 4200, color: 'danger' })).present(); }
}
